
import { createContext } from "react";

export const UserContext = createContext({
  user: null,
  setUser: () => {},
  decodedUser: null,
  setDecodedUser: () => {},
  isLoggedIn: false,
  setIsLoggedIn: () => {},
  login: (token) => {
    localStorage.setItem('token', token);
    sessionStorage.setItem('token', token);
  },
  logout: () => {
    localStorage.removeItem("user-id");
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user-id');
    sessionStorage.removeItem('session_active');
    sessionStorage.removeItem('session_start');
  },
  isTokenValid: () => true,
});
// ******************************************************** */
// src/services/contexts/UserContext.js
// import { createContext, useState, useEffect } from "react";
// import { jwtDecode } from "jwt-decode";

// export const UserContext = createContext();

// export const UserContextProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [decodedUser, setDecodedUser] = useState(null);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isInitialized, setIsInitialized] = useState(false);

//   // Check for existing token on component mount
//   useEffect(() => {
//     console.log("🔍 UserContext: Checking for existing token on mount");
//     const token = sessionStorage.getItem('token');
//     console.log("🔍 UserContext: Found token in sessionStorage:", token ? "Yes" : "No");
    
//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         const currentTime = Date.now() / 1000;
//         console.log("🔍 UserContext: Token expiry:", decoded.exp, "Current time:", currentTime);
        
//         if (decoded.exp > currentTime) {
//           console.log("🔍 UserContext: Token is valid, setting logged in state");
//           setDecodedUser(decoded);
//           setIsLoggedIn(true);
//         } else {
//           console.log("🔍 UserContext: Token expired, clearing");
//           sessionStorage.removeItem('token');
//           sessionStorage.removeItem('user-id');
//           setIsLoggedIn(false);
//         }
//       } catch (error) {
//         console.error('❌ UserContext: Error decoding token:', error);
//         sessionStorage.removeItem('token');
//         sessionStorage.removeItem('user-id');
//         setIsLoggedIn(false);
//       }
//     } else {
//       console.log("🔍 UserContext: No token found, setting logged out state");
//       setIsLoggedIn(false);
//     }
    
//     setIsInitialized(true);
//     console.log("🔍 UserContext: Initialization completed");
//   }, []);

//   const login = (token) => {
//     console.log("🔍 UserContext.login called with token:", token ? "Token received" : "No token");
    
//     if (!token) {
//       console.log("❌ UserContext: No token provided to login function");
//       return;
//     }
    
//     sessionStorage.setItem('token', token);
    
//     try {
//       const decoded = jwtDecode(token);
//       console.log("🔍 UserContext: Decoded user data:", decoded);
//       setDecodedUser(decoded);
//       setIsLoggedIn(true);
//       console.log("🔍 UserContext: Login state set to TRUE");
//     } catch (error) {
//       console.error('❌ UserContext: Error decoding token during login:', error);
//       sessionStorage.removeItem('token');
//       sessionStorage.removeItem('user-id');
//       setIsLoggedIn(false);
//       console.log("🔍 UserContext: Login state set to FALSE due to error");
//     }
//   };

//   const logout = () => {
//     console.log("🔍 UserContext: Logout called");
//     sessionStorage.removeItem('token');
//     sessionStorage.removeItem('user-id');
//     localStorage.removeItem('token');
//     localStorage.removeItem('user-id');
//     setUser(null);
//     setDecodedUser(null);
//     setIsLoggedIn(false);
//     console.log("🔍 UserContext: All storage cleared, login state set to FALSE");
//   };

//   const contextValue = {
//     user,
//     setUser,
//     decodedUser,
//     setDecodedUser,
//     isLoggedIn,
//     setIsLoggedIn,
//     login,
//     logout,
//     isInitialized, // Make sure this is included
//   };

//   console.log("🔍 UserContext: Current state - isLoggedIn:", isLoggedIn, "decodedUser:", decodedUser, "isInitialized:", isInitialized);

//   return (
//     <UserContext.Provider value={contextValue}>
//       {children}
//     </UserContext.Provider>
//   );
// };

// export default UserContextProvider;
// //********************************************************** */